/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { v4 as uuid } from 'uuid';
import { VIEW_KIND_SECTION } from '@jira/polaris__domain-view/src/viewKindTimeline.constants.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import type { Props, State } from './NavigationView.types.tsx';
import { createFakeId, updateContainerState } from './updateContainerState.tsx';

export const insertViewSet =
	(): Action<State, Props> =>
	async ({ setState, getState }, props) => {
		const { navigationRemote, cloudId, containerId } = props;
		if (
			!cloudId ||
			!containerId ||
			!navigationRemote ||
			getState().containers[containerId]?.isLoading ||
			!getState().containers[containerId]?.initialized
		) {
			return;
		}

		setState(
			updateContainerState(getState(), containerId, {
				views: [
					...getState().containers[containerId].views,
					{
						id: createFakeId(),
						polarisId: 0,
						name: '',
						localId: uuid(),
						isRenaming: true,
						isExpanded: false,
						views: [],
						viewType: VIEW_KIND_SECTION,
					},
				],
			}),
		);
	};
